import { SendEventProps } from '../../interface/biEvents';

export const mpClickedSkillsShowMore = () =>
    ({
        eventName: 'Gig page - Seller card - skills clicked show more',
    } satisfies SendEventProps);
